/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { isValidElement } from 'react';

/**
 * Checks if an element is a valid React element of a given component type.
 *
 * @param element - The element to test.
 * @param component - The component to match.
 */
const isComponentElement = (element, component) => /*#__PURE__*/isValidElement(element) && element.type === component;

export { isComponentElement };
